import React from 'react';
import styles from './Pagination.module.scss';
import { Button } from '../../Button';

//--------------------------------------
interface PaginationProps {
    totalPages?: number;
    currentPage: number;
    handlePageChange: (page: number) => void;
}

export default function Pagination(props: PaginationProps) {
    return (
        <>
            {props.totalPages !== undefined && props.totalPages > 1 && (
                <>
                    <div className={styles.pagination}>
                        <Button
                            mode="outline-no-arrow-disabled-transparent"
                            size="small"
                            width={80}
                            onClick={() => props.handlePageChange(props.currentPage - 1)}
                            disabled={props.currentPage === 1}
                        >
                            Previous
                        </Button>
                        <p className={`${styles.text}`}>
                            {props.currentPage} of {props.totalPages}
                        </p>
                        <Button
                            mode="outline-no-arrow-disabled-transparent"
                            size="small"
                            width={80}
                            onClick={() => props.handlePageChange(props.currentPage + 1)}
                            disabled={props.currentPage === props.totalPages}
                        >
                            Next
                        </Button>
                    </div>
                </>
            )}
        </>
    );
}
